import { createSlice } from "@reduxjs/toolkit";
import { ReadyToCastHeat } from "../models/catalogs.models";
import { DEProcess } from "../models/torches.models";

const DataEntryReducerInitialState: {
  isDataLoading: boolean;
  isSubmitLoading: boolean;
  errorMessage: string;
  arrive: boolean;
  open: boolean;
  notificationMessage: string;
  heats: ReadyToCastHeat[];
  heatSelected: ReadyToCastHeat | null;
  deProcess: DEProcess | null;
} = {
  errorMessage: "",
  notificationMessage: "",
  isDataLoading: false,
  isSubmitLoading: false,
  arrive: false,
  open: false,
  heats: [],
  heatSelected: null,
  deProcess: null,
};

export const DataEntryReducer = createSlice({
  name: "__",
  initialState: DataEntryReducerInitialState,
  reducers: {
    setIsDataLoading(state, { payload }) {
      state.isDataLoading = payload;
    },
    setIsSubmitLoading(state, { payload }) {
      state.isSubmitLoading = payload;
    },
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setArrive(state, { payload }) {
      state.arrive = payload;
    },
    setOpen(state, { payload }) {
      state.open = payload;
    },
    setNotificationMessage(state, { payload }) {
      state.notificationMessage = payload;
    },
    setDEProcess(state, { payload }) {
      state.deProcess = payload;
    },
    setHeats(state, { payload }) {
      state.heats = payload;
    },
    setHeatSelected(state, { payload }) {
      state.heatSelected = payload;
    },
    setProcess(state, { payload }) {
      if (state.deProcess) {
        state.deProcess.process = payload;
      }
      state.deProcess;
    },
  },
});
